import { useMediaQuery } from '@mantine/hooks'

export function useBreakpoint() {
  const isMobile = useMediaQuery('(max-width: 768px)')
  const isTablet = useMediaQuery('(max-width: 1024px)')
  const isSmall  = isMobile || isTablet  // ทั้ง mobile + tablet
  const isDesktop = !isTablet

  return { isMobile, isTablet, isSmall, isDesktop }
}
